import __vue_component__ from './ContentLoader.vue.js';

//

const random = () => Math.random() * (1 - 0.7) + 0.7;

var script = {
  name: 'PageDetailsLoader',
  components: {
    ContentLoader: __vue_component__
  },

  data() {
    return {
      random
    };
  }

};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/ContentLoader/PageDetailsLoader.vue_rollup-plugin-vue=script.js